import { useState, useEffect } from 'react'
import { getMarketInsightStatus, getMarketInsightLatest } from '../core/_requests'
import { MarketInsightLatestModel } from '../core/_models'

export function useMarketInsight() {
    const [data, setData] = useState<MarketInsightLatestModel | null>(null)
    const [isAvailable, setIsAvailable] = useState<boolean>(false)
    const [loading, setLoading] = useState<boolean>(true)
    const [error, setError] = useState<unknown>(null)

    useEffect(() => {
        const fetchInsight = async () => {
            try {
                setLoading(true)
                // 1. Check status
                const statusResponse = await getMarketInsightStatus()
                const status = statusResponse.data

                if (status.available) {
                    setIsAvailable(true)
                    // 2. Get latest
                    const latestResponse = await getMarketInsightLatest()
                    setData(latestResponse.data)
                } else {
                    setIsAvailable(false)
                    setData(null)
                }
            } catch (err) {
                console.error('Failed to fetch market insight:', err)
                setError(err)
                // Fallback to "Insight non disponibile" on error
                setIsAvailable(false)
            } finally {
                setLoading(false)
            }
        }

        fetchInsight()
    }, [])

    return { data, isAvailable, loading, error }
}
